export default class ClickableTableRow {
  constructor(node) {
    this.element = node;

    if (this.element.dataset.url) {
      this.element.classList.add("clickable-tr");
      this.url = new URL(this.element.dataset.url, window.location.origin);

      this.initialize();
    }
  }

  initialize() {
    this.element.addEventListener("click", () => {
      window.location.href = this.url;
    });
  }
}
